import { useState } from 'react';
import { PaidFeatures } from 'types/AppState';
import { getImagePreview, getVideoPreview } from 'utils/projects/projectPreview';
import { useAsync } from 'react-use';

type ThumbnailImageProps = {
  type: PaidFeatures;
  src: string;
};
export const ThumbnailImage = ({ type, src }: ThumbnailImageProps) => {
  const [imgSrc, setImgSrc] = useState(null);

  useAsync(async () => {
    const image =
      type === PaidFeatures.VideoChooser ? await getVideoPreview(src) : await getImagePreview(src);
    setImgSrc(image);
  }, [src]);

  if (imgSrc) {
    return (
      <img
        src={imgSrc}
        sx={{
          position: 'absolute',
          width: 40,
          height: 40,
          borderRadius: 8
        }}
        alt=""
      />
    );
  }

  return null;
};
